import { render, staticRenderFns } from "./CitySelectCom.vue?vue&type=template&id=2206228f&scoped=true"
import script from "./CitySelectCom.vue?vue&type=script&lang=js"
export * from "./CitySelectCom.vue?vue&type=script&lang=js"
import style0 from "./CitySelectCom.vue?vue&type=style&index=0&id=2206228f&prod&lang=scss&scoped=true"
import style1 from "./CitySelectCom.vue?vue&type=style&index=1&id=2206228f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206228f",
  null
  
)

export default component.exports